import {
  formValidation,
  images,
  scrolling,
} from 'assets/utilities';

import './login.scss';

const STATE_CLASSNAME = 'state--login';

const CLASSNAME_RECOVER_FORM_SHOW = 'login--recover';
const CLASSNAME_RECOVER_FORM_SUCCESS = 'login--recover-success';
const ERROR_ALREADY_SUBMITTED = 'You\'ve already submitted a password reset request. Please check your inbox.';
const ERROR_GENERAL = 'An error occurred. Please try again later.';
const ERROR_CONTAINER_SELECTOR = '.js-loginRecoverErrors';
const SELECTOR_RECOVER_BUTTON = '.js-loginRecoverToggle';
const SELECTOR_HEADING = '.js-loginHeading';
const SELECTOR_FORM_RECOVER = '.js-loginRecover';
const SELECTOR_FORM_RECOVER_HEADING = '.js-loginRecoverHeading';
const SELECTOR_LOGIN_CONTAINER = '.js-login';
const MESSAGE_TIMEOUT = 6000;

const INIT_STATE = {
  loginFormContainer: null,
  loginHeading: null,
  recoverForm: null,
  recoverHeading: null,
  recoveryErrorContainer: null,
  recoverFormEl: null,
};

let state = { ...INIT_STATE };

const onRecoverClick = function onLoginRecoverButtonClick(e) {
  if (e) {
    e.preventDefault();
  }
  const { loginFormContainer, loginHeading, recoverHeading } = state;
  loginFormContainer.classList.toggle(CLASSNAME_RECOVER_FORM_SHOW);
  loginFormContainer.classList.remove(CLASSNAME_RECOVER_FORM_SUCCESS);

  setTimeout(() => {
    if (!loginFormContainer.classList.contains(CLASSNAME_RECOVER_FORM_SHOW)) {
      loginHeading.focus();
    } else {
      recoverHeading.focus();
    }
  }, 100);
};

const displayMessage = function displayMessage(text = '') {
  if (!text) {
    state.recoveryErrorContainer.innerHTML = '';
    return;
  }
  state.recoveryErrorContainer.innerHTML = `<p>${text}</p>`;
  clearTimeout(state.errorTimeout);
  state.errorTimeout = setTimeout(() => {
    state.recoveryErrorContainer.innerHTML = '';
  }, MESSAGE_TIMEOUT);
};

const onSuccess = function onFormSubmitSuccess() {
  state.loginFormContainer.classList.add(CLASSNAME_RECOVER_FORM_SUCCESS);
};

const proccessResponse = function proccessResponse(text) {
  let error = text.split('<div class="errors"><ul><li>')[1] || '';
  error = error.split('</li></ul></div>')[0] || '';

  if (error) {
    displayMessage(error);
    return;
  }

  onSuccess();
};

const handleRequest = function handleRequest(request) {
  if (request.status === 200) {
    proccessResponse(request.responseText);
  } else if (request.status === 429) {
    displayMessage(ERROR_ALREADY_SUBMITTED);
  } else {
    displayMessage(ERROR_GENERAL);
  }
};

const onRecoverSubmit = function onRecoverFormSubmit(_el, e) {
  e.preventDefault();
  const params = [
    `form_type=${state.recoverFormEl.form_type.value}`,
    `utf8=${state.recoverFormEl.utf8.value}`,
    `email=${encodeURI(state.recoverFormEl.email.value)}`,
  ];

  const request = new XMLHttpRequest();

  request.open('POST', state.recoverFormEl.action, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  request.onload = () => {
    handleRequest(request);
  };
  request.send(params.join('&'));
};

const destroy = function destroyLogin() {
  document.body.classList.remove(STATE_CLASSNAME);
  state = { ...INIT_STATE };
};

const bind = function bindLogin() {
  [].map.call(
    document.querySelectorAll(SELECTOR_RECOVER_BUTTON),
    (button) => {
      button.removeEventListener('click', onRecoverClick);
      button.addEventListener('click', onRecoverClick);
    },
  );
};

const init = function initLogin() {
  document.body.classList.add(STATE_CLASSNAME);
  window.scrollTo(0, 0);
  scrolling.rebuildCache();

  state.loginFormContainer = document.querySelector(SELECTOR_LOGIN_CONTAINER);
  state.recoverForm = document.querySelector(SELECTOR_FORM_RECOVER);
  state.loginHeading = document.querySelector(SELECTOR_HEADING);
  state.recoverHeading = document.querySelector(SELECTOR_FORM_RECOVER_HEADING);

  bind();
  images.init();
  formValidation.init();

  if (state.recoverForm) {
    state.recoverFormEl = state.recoverForm.querySelector('form');
    state.recoveryErrorContainer = state.recoverFormEl.querySelector(ERROR_CONTAINER_SELECTOR);
    formValidation.bind(state.recoverFormEl, onRecoverSubmit);
  }
};

export default {
  destroy,
  init,
};
